export const useSearchResultsRenderer = ({
  isLoading,
  hasSearchResults,
  hasSearchInput,
  searchResults,
}: any) => {
  let showSearchResults,
    showLoading,
    showNoResultsFound,
    showRecentSearches = false;

  if (isLoading && !hasSearchResults && hasSearchInput) {
    showLoading = true;
  } else if (
    //API sends empty array if nothing was found
    Array.isArray(searchResults) &&
    searchResults.length === 0 &&
    hasSearchInput
  ) {
    showNoResultsFound = true;
  } else if (!hasSearchInput) {
    showRecentSearches = true;
  } else if (hasSearchResults) {
    showSearchResults = true;
  }

  return {
    showSearchResults,
    showLoading,
    showNoResultsFound,
    showRecentSearches,
  };
};
